import { useMemo } from "react";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";

const classNames = {
  root: `AddressValidationRoot`
};

export function useAddressValidationStyles() {
  return useMemo(
    () => mergeStyleSets({
      root: [
        classNames.root,
        {
          height: `100%`,
          overflowY: `scroll`,
          padding: `0 5px 0 2px`
        }
      ]
    }),
    []
  );
}
